(function () {
  'use strict';

  var lb = null;
  var imgEl = null;
  var filmstripEl = null;
  var counterEl = null;
  var images = [];
  var currentIndex = 0;
  var savedOverflow = '';
  var keyListenerAttached = false;
  var returnFocusEl = null;

  function buildOverlay() {
    var el = document.createElement('div');
    el.id = 'pdp-lightbox';
    el.className = 'pdp-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product image viewer');
    el.innerHTML =
      '<div class="pdp-lightbox__backdrop"></div>' +
      '<span class="pdp-lightbox__counter" aria-live="polite" aria-atomic="true"></span>' +
      '<button class="pdp-lightbox__close" aria-label="Close">&#x2715;</button>' +
      '<div class="pdp-lightbox__stage">' +
        '<button class="pdp-lightbox__arrow pdp-lightbox__arrow--prev" aria-label="Previous image">&#8592;</button>' +
        '<img class="pdp-lightbox__image" src="" alt="">' +
        '<button class="pdp-lightbox__arrow pdp-lightbox__arrow--next" aria-label="Next image">&#8594;</button>' +
      '</div>' +
      '<div class="pdp-lightbox__filmstrip"></div>';

    document.body.appendChild(el);

    imgEl = el.querySelector('.pdp-lightbox__image');
    filmstripEl = el.querySelector('.pdp-lightbox__filmstrip');
    counterEl = el.querySelector('.pdp-lightbox__counter');

    el.querySelector('.pdp-lightbox__backdrop').addEventListener('click', close);
    el.querySelector('.pdp-lightbox__close').addEventListener('click', close);
    el.querySelector('.pdp-lightbox__arrow--prev').addEventListener('click', prev);
    el.querySelector('.pdp-lightbox__arrow--next').addEventListener('click', next);

    return el;
  }

  function show(idx) {
    if (!lb || !lb.classList.contains('is-open')) return;
    currentIndex = ((idx % images.length) + images.length) % images.length;
    var item = images[currentIndex];
    imgEl.src = item.src;
    imgEl.srcset = item.srcset || '';
    imgEl.alt = item.alt || '';
    counterEl.textContent = (currentIndex + 1) + ' / ' + images.length;

    var thumbs = filmstripEl.querySelectorAll('.pdp-lightbox__film-thumb');
    Array.prototype.forEach.call(thumbs, function (t, i) {
      t.classList.toggle('is-active', i === currentIndex);
    });
    if (thumbs[currentIndex]) {
      thumbs[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function buildFilmstrip() {
    filmstripEl.innerHTML = '';
    images.forEach(function (item, i) {
      var btn = document.createElement('button');
      btn.className = 'pdp-lightbox__film-thumb';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      btn.addEventListener('click', function () { show(i); });

      var img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || '';
      img.width = 56;
      img.height = 56;
      img.loading = 'lazy';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.display = 'block';

      btn.appendChild(img);
      filmstripEl.appendChild(btn);
    });
  }

  // Can this element actually take focus right now? A hidden subtree has no
  // box, so it reports zero size and no client rects.
  function isFocusableNow(el) {
    return !!(el && el.nodeType === 1 && typeof el.focus === 'function' &&
      document.contains(el) && !el.disabled &&
      (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0));
  }

  function open(imgs, startIndex) {
    if (!lb) lb = buildOverlay();
    images = imgs || [];
    if (!images.length) return;

    // Remembered before the overlay is shown. <body> is not a return target (a
    // mouse click in Safari leaves focus there) and neither is anything inside
    // the lightbox itself. Nothing above has moved focus.
    var opener = document.activeElement;
    returnFocusEl = (opener && opener !== document.body && !lb.contains(opener))
      ? opener
      : null;

    buildFilmstrip();
    lb.classList.add('is-open');
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    show(typeof startIndex === 'number' ? startIndex : 0);
    if (!keyListenerAttached) {
      document.addEventListener('keydown', onKeyDown);
      keyListenerAttached = true;
    }
    var closeBtn = lb.querySelector('.pdp-lightbox__close');
    if (isFocusableNow(closeBtn)) closeBtn.focus();
  }

  function close() {
    if (lb) lb.classList.remove('is-open');
    document.body.style.overflow = savedOverflow;
    var returnTo = returnFocusEl;
    returnFocusEl = null;
    // The thumbnail that opened the lightbox can be gone (variant swap
    // re-renders the gallery), so never assume it is still focusable.
    if (isFocusableNow(returnTo)) {
      try { returnTo.focus(); } catch (err) { /* element became unfocusable */ }
    }
  }

  function prev() { show(currentIndex - 1); }
  function next() { show(currentIndex + 1); }

  function onKeyDown(e) {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  }

  window.PdpLightbox = { open: open, close: close };
})();
